import { styled } from "@mui/material";
import { actionHeaderName } from "../classes.js";
const PrimaryAction = styled("div", {
  name: actionHeaderName,
  slot: "PrimaryAction",
  shouldForwardProp: (prop) => prop !== "ownerState",
  overridesResolver: (props, styles) => {
    const { ownerState } = props;
    return [styles.primaryAction, ownerState?.primaryActionVisibility === "hover" && styles.primaryActionHover];
  }
})(({ theme, ownerState }) => ({
  display: "flex",
  alignItems: "center",
  marginRight: theme.spacing(0.5),
  ...ownerState?.primaryActionVisibility === "hover" && {
    display: "none"
  }
}));
export {
  PrimaryAction
};
//# sourceMappingURL=PrimaryAction.js.map
